import { render, staticRenderFns } from "./PlanningGroupsSettingsDialog.vue?vue&type=template&id=71a68104&scoped=true&lang=pug&"
import script from "./PlanningGroupsSettingsDialog.vue?vue&type=script&lang=ts&"
export * from "./PlanningGroupsSettingsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PlanningGroupsSettingsDialog.vue?vue&type=style&index=0&id=71a68104&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a68104",
  null
  
)

export default component.exports